export var ContributionMetric;
(function (ContributionMetric) {
    ContributionMetric["WEIGHT"] = "weight";
    ContributionMetric["DOLLARS"] = "dollars";
})(ContributionMetric || (ContributionMetric = {}));
